import Service, { service } from '@ember/service';
import { queryManager } from 'ember-apollo-client';

import requestFutureAppointmentPrint from 'my-phorest/gql/mutations/request-future-appointment-print.graphql';
import { dropTask, task } from 'ember-concurrency';
import SendFutureAppointments from 'my-phorest/gql/mutations/send-future-appointments.graphql';

export const DATE_EPOCH_BEGINNING = '2000-01-01';

export default class BookingHistoryService extends Service {
  @service swingBridge;
  @service notifications;
  @service intl;
  @queryManager apollo;

  @dropTask
  *printFutureBookingsReceiptTask(clientId) {
    const terminalId = yield this.swingBridge.getPrintTerminalId.perform();

    return yield this.apollo.mutate(
      {
        mutation: requestFutureAppointmentPrint,
        variables: {
          clientId,
          terminalId,
        },
      },
      'requestFutureAppointmentPrint'
    );
  }

  @task
  *emailFutureAppointmentsTask(clientId) {
    yield this.apollo.mutate({
      mutation: SendFutureAppointments,
      variables: { clientId },
    });
    this.notifications.success(
      this.intl.t(
        'event-slider.booking-history-tab.future-appointments-modal.email-sent'
      )
    );
  }
}
